var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialDisable28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14c0 6.627 5.373 12 12 12s12-5.373 12-12S20.627 2 14 2 2 7.373 2 14Zm3 0a9 9 0 0 0 12.57 8.264c.48-.208.721-.312.886-.564.127-.196.189-.517.142-.746-.06-.295-.28-.515-.72-.955L8 10.123c-.44-.44-.66-.66-.955-.72-.23-.048-.55.014-.746.141-.252.165-.356.405-.564.886A8.97 8.97 0 0 0 5 14Zm17.264 3.57c-.208.481-.312.721-.564.886a1.116 1.116 0 0 1-.746.142c-.295-.06-.515-.28-.955-.72L10.123 8c-.44-.44-.661-.66-.721-.955-.047-.23.014-.55.142-.746.165-.252.405-.356.885-.564a9 9 0 0 1 11.835 11.835Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialDisable28);
export default __webpack_public_path__ + "static/media/social_disable_28.4115a6af.svg";
export { ForwardRef as ReactComponent };